module.exports = __webpack_public_path__ + "static/media/bg.a02e282d.jpg";